/**
 * Utilidades para manejo de monedas
 */

// Mapeo de códigos de moneda a símbolos
export const CURRENCY_SYMBOLS: Record<string, string> = {
    'USD': '$',    // Dólar estadounidense
    'EUR': '€',    // Euro
    'CUP': '$',    // Peso cubano (mismo símbolo)
    'L': 'L',      // Lempira hondureño
    'MXN': '$',    // Peso mexicano
  };
  
  // Nombres completos de monedas
  export const CURRENCY_NAMES: Record<string, string> = {
    'USD': 'Dólar Estadounidense',
    'EUR': 'Euro',
    'CUP': 'Peso Cubano',
    'L': 'Lempira Hondureño',
    'MXN': 'Peso Mexicano',
  };
  
  /**
   * Formatea un monto con el símbolo de moneda
   */
  export function formatCurrency(
    amount: number, 
    currencyCode: string = 'CUP',
    options: Intl.NumberFormatOptions = {}
  ): string {
    const symbol = CURRENCY_SYMBOLS[currencyCode] || '$';
    
    // Configuración regional según moneda
    const locales: Record<string, string> = {
      'USD': 'en-US',
      'EUR': 'de-DE',  // Alemania como ejemplo para Euro
      'CUP': 'es-CU',
      'L': 'es-HN',
      'MXN': 'es-MX',
    };
    
    const locale = locales[currencyCode] || 'es-CU';
    
    const formatter = new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options
    });
    
    return `${symbol}${formatter.format(amount)}`;
  }
  
  /**
   * Obtiene el nombre completo de una moneda
   */
  export function getCurrencyName(code: string): string {
    return CURRENCY_NAMES[code] || code;
  }
  
  /**
   * Valida si un código de moneda es válido
   */
  export function isValidCurrency(code: string): boolean {
    return code in CURRENCY_SYMBOLS;
  }

  /**
 * Obtiene el nombre y símbolo de una moneda formateados
 * Ejemplo: "Peso Cubano (CUP) - $"
 */
export function getCurrencyDisplayName(code: string): string {
  const name = CURRENCY_NAMES[code] || code;
  const symbol = CURRENCY_SYMBOLS[code] || '$';
  return `${name} (${code}) - ${symbol}`;
}